export default {
  patientsPayments: state => state.patientsPayments,
  patientsPaymentsCount: state => state.patientsPaymentsCount,
  getCashRegisterTotal: state => state.cash_register_total,
  totalByDirection: state => state.totalByDirection,
  getTotalBySnapshot: state => state.total_by_snapshot,
  getTotalBySelling: state => state.total_by_selling,
  getTotalByPrepayment: state => state.total_by_prepayment,
  getTotalByDiscount: state => state.total_by_discount,
  debtors: state => state.debtors,
  advances: state => state.advances,
  insurancesPerPage: state => state.insurancesPerPage,
  insurancesPerPageTotalCount: state => state.insurancesPerPageTotalCount,
  getCertificates: state => state.certificates,
  certificatesPerPage: state => state.certificatesPerPage,
  certificatesPerPageTotalCount: state => state.certificatesPerPageTotalCount,
  getCashlessPayments: state => state.cashlessPayments,
  getCashRegisterSections: state => state.cashRegisterSections && state.cashRegisterSections.length
    ? state.cashRegisterSections : [],
  goToPaymentInfo: state => state.goToPaymentInfo,
  materialsWriteOff: state => state.materialsWriteOff
}
